<template>
  <div>
    <!-- Modal Overlay -->
    <div v-if="visible" class="modal-overlay" @click="closeModal">
      <!-- Modal Content -->
      <div class="modal-content" @click.stop>
        <!-- Close Button -->
        <button class="close-button" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>

        <!-- Modal Header -->
        <h2 class="modal-header">Delad glädje, dubbel glädje!</h2>

        <!-- Modal Body -->
        <div class="modal-body">
          <p class="last-p">Tipsa det här eventet till någon du bryr dig om! 😍</p>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button
            class="action-btn copy-btn"
            :class="{'copy-success': copySuccess}"
            @click="copyToClipboard"
          >
            <span v-if="copied" class="checkmark">✔️</span>
            <span v-else>📋 Kopiera</span>
          </button>
          <button class="action-btn email-btn" @click="sendEmail">
            ✉️ Email
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareEventModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  data() {
    return {
      copied: false, // Controls showing the checkmark
      copySuccess: false, // Tracks if the copy was successful
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    copyToClipboard() {
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.copied = true; // Show the checkmark
        this.copySuccess = true; // Trigger the animation class
        setTimeout(() => {
          this.copied = false; // Hide the checkmark after 1 second
          this.copySuccess = false; // Reset the animation
        }, 1000); // Duration for which the checkmark is shown and animation is active
      });
    },
    sendEmail() {
      const subject = encodeURIComponent("Kolla in detta evenemanget");
      const body = encodeURIComponent("Du kan hitta det på Eventstaden.se");
      window.location.href = `mailto:?subject=${subject}&body=${body}`;
    },
  },
};
</script>

<style scoped>
/* Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal Content */
.modal-content {
  background: white;
  color: black;
  width: 90%;
  max-width: 400px;
  border-radius: 10px;
  padding: 20px;
  position: relative;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Close Button */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: black;
  cursor: pointer;
}

/* Header */
.modal-header {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
}

/* Modal Body */
.modal-body {
  /* width: 100%; */
  margin-bottom: 20px;
  font-size: 15px;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  justify-content: space-around;
  gap: 10px;
}

/* Action Buttons */
.action-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  position: relative;
  width: 140px;
  height: 40px;
}

.copy-btn {
  background-color: #e0e0ff;
}

.copy-btn:hover {
  background-color: #c0c0ff;
}

.email-btn {
  background-color: #ffe0e0;
}

.email-btn:hover {
  background-color: #ffc0c0;
}

/* Success Animation for Copy Button */
.copy-success {
  animation: success-animation 1s ease-in-out;
}

/* Checkmark inside the button */
.checkmark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px; /* Adjust size to fit the button */
  color: green;
}

/* Animation for success state */
@keyframes success-animation {
  0% {
    transform: scale(1);
    background-color: #e0e0ff;
  }
  50% {
    transform: scale(1.1);
    background-color: #a0a0ff;
  }
  100% {
    transform: scale(1);
    background-color: #e0e0ff;
  }
}
</style>
